<template>
    <app-layout-new :title="form.title +' | '+ tour_title" :form="form"
    :update="updateStation">
        <template v-slot:left-area>
            <div class="my-5 text-center">
            <Link :href="route('tour.edit', tour_identifier)" class="btn btn-gradient btn-sm">
                Back
            </Link>
            </div>
            <left-area-stations :changeLanguage="changeLanguage"
            :station_id="$page.props.station.data.id" />
        </template>

        <div class="flex lang-box">
            <a v-for="(lang, index) in languages" href="#" @click.prevent="changeLanguage(lang)" :key="index"
            :class="{active:(form.current_language == lang)}">{{ showFallbackLang(lang) }}</a>
        </div>

        <section class="border border-gray-800 p-3">
            <h3 class="text-white text-2xl font-bold uppercase">General</h3>
            <div class="flex">
                <label>Title</label>
                <span v-if="errors.title" class="errormessage">{{ errors.title }}</span>
            </div>
            <input class="input-black" type="text" id="copyright_text" v-model="form.title">

            <div class="flex">
                <label>Subtitle</label>
                <span v-if="errors.description" class="errormessage">{{ errors.description }}</span>
            </div>
            <input class="input-black" type="text" id="copyright_text" v-model="form.description">

        </section>

        <section class="border border-gray-800 p-3">
            <h3 class="text-white text-2xl font-bold uppercase">Location</h3>
            <div class="flex">
                <div class="w-2/3 p-3">
                    <MapsPlugin
                        v-bind:latitude="parseFloat(form.latitude)"
                        v-bind:longitude="parseFloat(form.longitude)"
                        @update:location="updateLocation($event)"
                    ></MapsPlugin>
                </div>
                <div class="w-1/3 p-3">
                    <div class="flex">
                        <label>Latitude</label>
                        <span v-if="errors.latitude" class="errormessage">{{ errors.latitude }}</span>
                    </div>
                    <input class="input-black" type="number" v-model="form.latitude" v-on:change="">

                    <div class="flex">
                        <label>Longitude</label>
                        <span v-if="errors.longitude" class="errormessage">{{ errors.longitude }}</span>
                    </div>
                    <input class="input-black" type="number" v-model="form.longitude" v-on:change="">
                </div>
            </div>
        </section>


        <section class="border border-gray-800 p-3">
            <div class="flex">
                <UploadBox name="Station Logo" type="logo_file"
                           :form="form"
                           :changeUploadBoxState="changeUploadBoxState"
                           uploadPlace="station-logo"
                           :current_language="form.current_language"
                           :changeLanguage="changeLanguage"
                           :showPreventFallbackLangModal="showPreventFallbackLangModal"
                           :deleteInAllLanguagesFormRunning="deleteInAllLanguagesFormRunning"
                           :hidePreventFallbackLangModal="hidePreventFallbackLangModal"
                />

                <UploadBox name="Station preview image" type="preview_file"
                           :form="form"
                           :changeUploadBoxState="changeUploadBoxState"
                           uploadPlace="station-image"
                           :current_language="form.current_language"
                           :changeLanguage="changeLanguage"
                           :showPreventFallbackLangModal="showPreventFallbackLangModal"
                           :deleteInAllLanguagesFormRunning="deleteInAllLanguagesFormRunning"
                           :hidePreventFallbackLangModal="hidePreventFallbackLangModal"
                />

                <PreventFallbackLanguageModal
                    :showModal="preventFallbackLanguageModalShow"
                    :hideModalFn="hidePreventFallbackLangModal"
                    :runDeleteInAllLanguagesForm="runDeleteInAllLanguagesForm"
                    :deleteInAllLanguagesFormRunning="deleteInAllLanguagesFormRunning"
                    :deleteInAllLanguagesGalleryImageFormRunning="deleteInAllLanguagesGalleryImageFormRunning"
                    :preventFallbackLanguageModalContext="preventFallbackLanguageModalContext"
                />

            </div>
        </section>

        <section class="border border-gray-800 p-3">
            <div class="flex mb-5">
                <h3 class="text-white text-2xl font-bold uppercase mr-5">Gallery</h3>
                <Modal
                    :ref="'galleryModal'"
                    :button-text="'add'"
                    :title="'Add gallery item'">

                    <template #toggler="{ toggle }">
                        <button class="btn btn-sm btn-black" @click="toggle(true)">
                            <i class="add"></i>
                        </button>
                    </template>

                    <GalleryAddItemSection
                        :current_language="form.current_language"
                        :updateGallery="updateGallery"
                        :changeUploadBoxState="changeUploadBoxState"
                        :form="gallery_form"
                        :onGalleryItemSubmitted="onGalleryItemSubmitted"
                        v-if="form.fallback_language == form.current_language"
                    />
                </Modal>
            </div>

            <GalleryItemsSection
                :current_language="form.current_language"
                :gallery="gallery"
                :updateGallery="updateGallery"
                :changeUploadBoxState="changeUploadBoxState"
                :form="gallery_update_item_form"
                :showPreventFallbackLangModal="showPreventFallbackLangModal"
                :deleteInAllLanguagesGalleryImageFormRunning=
                "deleteInAllLanguagesGalleryImageFormRunning"
                :hidePreventFallbackLangModal="hidePreventFallbackLangModal"
            />
        </section>

        <section class="border border-gray-800 p-3">
            <h3 class="text-white text-2xl font-bold uppercase mb-3">Features</h3>
            <div class="grid grid-cols-1 sm:grid-cols-7 gap-3">
                <FeatureAdd :func="showCreateFeatureSelectModal" />

                <FeaturePreviewBox v-for="feature in features" :feature="feature"
                :showFeatureDeleteConfirmationModal="showFeatureDeleteConfirmationModal"
                :showEditFeatureForm="showEditFeatureForm" />

                <FeatureDeleteConfirmationModal
                :showModal="delete_feature_form.showModal"
                :form="delete_feature_form"
                :delete_feature_id="delete_feature_id"
                :hideModalFn="()=>{delete_feature_form.showModal = false; delete_feature_id = null}"
                />

                <EditFeaturesModals
                    :current_feature_edit_box="current_feature_edit_box"
                    :closeEditFeatureModal="closeEditFeatureModal"
                    :current_edit_feature_id="current_edit_feature_id"
                />
            </div>
        </section>

        <button v-if="!form.processing" @click.prevent="updateStation" class="btn btn-gradient mt-2 mb-10">Update station</button>
        <button v-else class="btn btn-gradient mt-2 mb-10"><Spinner/></button>

        <span v-if="form.recentlySuccessful" class="ml-3 text-white">
            Updated
        </span>

    </app-layout-new>
    <CreateFeatureSelectModal
        :feature_panorama_form="feature_panorama_form"
        :feature_audioguide_form="feature_audioguide_form"
        :feature_video_form="feature_video_form"
        :feature_text_form="feature_text_form"
        :feature_augmented_reality_form="feature_augmented_reality_form"
        :feature_map_form="feature_map_form"
        :showModal="createFeatureSelectModal"
        :closeModal="closeCreateFeatureSelectModal"
        :changeUploadBoxState="changeUploadBoxState" />

    <MediaLibrary
        :uploadBoxState="uploadBoxState"
        :changeUploadBoxState="changeUploadBoxState"
        :select="selectFileFromMediaLibrary"
    />

</template>

<script>
import AppLayoutNew from '@/Layouts/AppLayoutNew.vue'
import FormInputText from '@/UI/FormInputText'
import FormInputNumber from '@/UI/FormInputNumber'
import { Link } from '@inertiajs/inertia-vue3'
import FeatureAdd from './Partials/Features/FeatureAdd'
import FeaturePreviewBox from './Partials/Features/FeaturePreviewBox'
import CreateFeatureSelectModal from '@/Pages/Station/Partials/Features/CreateFeatureSelectModal'
import UploadBox from './Partials/UploadBox'
import GalleryAddItemSection from './Gallery/GalleryAddItemSection'
import GalleryItemsSection from './Gallery/GalleryItemsSection'
import MediaLibrary from '@/Pages/Media/MediaLibrary';
import Spinner from '@/UI/Spinner';
import { changeUploadBoxState, selectFileFromMediaLibrary } from '@/Pages/Media/MediaLibraryLogic.js';
import { showFallbackLang } from '@/Pages/GlobalHelpers';
import FeatureDeleteConfirmationModal from './Partials/Features/FeatureDeleteConfirmationModal';
import EditFeaturesModals from './Partials/Features/EditFeaturesModals';
import { showFeatureDeleteConfirmationModal, showEditFeatureForm, closeEditFeatureModal } from './Partials/Features/FeaturesLogic';
import PreventFallbackLanguageModal from '@/Modals/PreventFallbackLanguageModal';
import Modal from "@/Components/Modal";
import MapsPlugin from "@/Components/MapsPlugin";
import {
    showPreventFallbackLangModal,
    hidePreventFallbackLangModal,
    runDeleteInAllLanguagesForm
} from '@/Pages/GlobalHelpers';
import LeftAreaStations from '@/UI/LeftAreaStations';

export default {
    components: {
        MapsPlugin,
        AppLayoutNew,
        FormInputText,
        FormInputNumber,
        Link,
        FeatureAdd,
        FeaturePreviewBox,
        CreateFeatureSelectModal,
        UploadBox,
        GalleryAddItemSection,
        GalleryItemsSection,
        MediaLibrary,
        Spinner,
        FeatureDeleteConfirmationModal,
        EditFeaturesModals,
        PreventFallbackLanguageModal,
        Modal,
        LeftAreaStations,
    },
    props: {
      errors: Object,
    },
    mounted(){
        this.changeLanguage(this.$page.props.tour.data.fallback_language);
        this.tour_title = this.$page.props.tour.data.title.localized_text[this.form.current_language];
    },
    updated(){
        this.features = this.$page.props.station.data.features;
    },
    data(){
        return{
            tour_identifier: this.$page.props.tour.data.identifier,
            tour_title: this.$page.props.tour.data.title,
            languages: this.$page.props.tour.data.languages,
            features: this.$page.props.station.data.features,
            gallery: this.$page.props.station.data.gallery,
            fileTypeInMediaModal: null,
            // location: {
            //     lat: this.$page.props.station.data.location.latitude,
            //     lng: this.$page.props.station.data.location.longitude,
            // },
            form: this.$inertia.form({
                _method: 'POST',
                title: null,
                description: null,
                // those are overriden when MapComponent Initializes
                latitude: this.$page.props.station.data.location.latitude,
                longitude: this.$page.props.station.data.location.longitude,
                tour_identifier: this.$page.props.tour.data.identifier,
                current_language: null,
                fallback_language: this.$page.props.tour.data.fallback_language,
                station_files: {
                    preview_file: {
                        file_type: 'image',
                        file: null,
                        copyright_link: '',
                        copyright_text: '',
                        loaded_file_path: '',
                        from_media_library_id: null,
                    },
                    logo_file: {
                        file_type: 'image',
                        file: null,
                        copyright_link: '',
                        copyright_text: '',
                        loaded_file_path: '',
                        from_media_library_id: null,
                    },
                }
            }),
            createFeatureSelectModal: false,
            uploadBoxState: null,
            //forms for gallery images
            gallery_form: this.$inertia.form({
              _method: 'POST',
              current_language: this.$page.props.tour.data.fallback_language,
              fallback_language: this.$page.props.tour.data.fallback_language,
              title: '',
              description: '',
              file: null,
              tour_identifier: this.$page.props.tour.data.identifier,
              loaded_file_path: '',
              from_media_library_id: false,
            }),
            gallery_update_item_form: this.$inertia.form({
                _method: 'POST',
                item_id: null,
                title: null,
                description: null,
                file: null,
                language: this.$page.props.tour.data.fallback_language,
                tour_identifier: this.$page.props.tour.data.identifier,
                loaded_file_path: '',
                from_media_library_id: null,
                station_id: this.$page.props.station.data.id
            }),
            // ==== end forms for gallery images
            //form for panorama feature
            feature_panorama_form: this.$inertia.form({
                _method: 'POST',
                current_filetype: 'panorama_image',
                current_language: this.$page.props.tour.data.fallback_language,
                with_audio: false,
                feature_files: this.generateFeatureFiles(),
                request_type: 'add_station_feature',
                fallback_language: this.$page.props.tour.data.fallback_language,
            }),
            //form for audioguide feature
            feature_audioguide_form: this.$inertia.form({
                _method: 'POST',
                feature_audio_files: this.generateLanguagesForAudioInAudioGuideFeature(),
                feature_audio_preview_images: this.generatePreviewImagesInAudioGuideFeature(),
                fallback_language: this.$page.props.tour.data.fallback_language,
                current_language: this.$page.props.tour.data.fallback_language,
            }),
            //form for video feature
            feature_video_form: this.$inertia.form({
                _method: 'POST',
                current_language: this.$page.props.tour.data.fallback_language,
                feature_video_files: this.generateFeatureVideoFiles(),
                request_type: 'add_station_feature',
                fallback_language: this.$page.props.tour.data.fallback_language,
            }),
            //form for text feature
            feature_text_form: this.$inertia.form({
                _method: 'POST',
                current_language: this.$page.props.tour.data.fallback_language,
                request_type: 'add_station_feature',
                fallback_language: this.$page.props.tour.data.fallback_language,
                headline: this.generateLanguagesForTextFields(),
                text: this.generateLanguagesForTextFields(),
            }),
            //form for augmented reality feature
            feature_augmented_reality_form: this.$inertia.form({
                _method: 'POST',
                general: {
                    scale_percentage: 100,
                    animation_loop: false,
                    subtype: 'ar-markerbased',
                    with_audio: true,
                    marker_file: null,
                    marker_position: [0,0,0],
                    marker_rotation: [0,0,0],
                    loop_audio: true,
                    volume_percentage: 50,
                },
                languages: this.generateLangsForAugmentedRealityFeature(),
                fallback_language: this.$page.props.tour.data.fallback_language,
                current_language: this.$page.props.tour.data.fallback_language,
            }),
            // form for map feature
            feature_map_form: this.$inertia.form({
                _method: 'POST',
            }),
            //edit features logic
            current_edit_feature_id: null,
            current_feature_edit_box: null,
            //delete features form
            delete_feature_form: this.$inertia.form({
                _method: 'POST',
                showModal: false,
            }),
            delete_feature_id: null,
            //prevent modal in fallback language
            preventFallbackLanguageModalContext: null,
            preventFallbackLanguageModalShow: false,
            deleteInAllLanguagesFormRunning: false,
            deleteInAllLanguagesGalleryImageFormRunning: false,
        }
    },
    methods: {
        updateLocation(e) {
            this.form.latitude = e.detail.lat;
            this.form.longitude = e.detail.lng;
        },

        onGalleryItemSubmitted() {
            this.$refs.galleryModal.toggle(false)
        },

        updateStation(e){
            this.form.post(route('station.update', this.$page.props.station.data.id), {
                preserveScroll: true,
              onSuccess: () => {
                this.changeLanguage(this.$page.props.tour.data.fallback_language);
              },
              onError: (err) => {
                //
              }
            });
        },
        changeLanguage(lang){
            this.clearErrors();
            this.form.current_language = lang;
            this.form.title = this.$page.props.station.data.title.localized_text[lang];
            this.form.description = this.$page.props.station.data.description.localized_text[lang];
            this.form.station_files.logo_file.loaded_file_path = (this.$page.props.station.data.logo && this.$page.props.station.data.logo.filter(el=> el.language == lang).length)
            ? this.$page.props.station.data.logo.filter(el=> el.language == lang)[0]['first_file_path'] : null;
            this.form.station_files.preview_file.loaded_file_path = (this.$page.props.station.data.image && this.$page.props.station.data.image.filter(el=> el.language == lang).length)
            ? this.$page.props.station.data.image.filter(el=> el.language == lang)[0]['first_file_path'] : null;
            this.form.station_files.preview_file.file = null;
            this.form.station_files.logo_file.file = null;
            this.form.station_files.preview_file.from_media_library_id = null;
            this.form.station_files.logo_file.from_media_library_id = null;
            this.gallery_form.loaded_file_path = '';
            this.gallery_form.from_media_library_id = false;
            this.gallery_update_item_form.loaded_file_path = '';
            this.gallery_update_item_form.from_media_library_id = false;
        },
        showCreateFeatureSelectModal() {
            this.createFeatureSelectModal = true;
            this.initStateInAllFeatures();
        },
        closeCreateFeatureSelectModal() {
            this.createFeatureSelectModal = false;
        },
        updateGallery(){
            this.gallery = this.$page.props.station.data.gallery ?
            this.$page.props.station.data.gallery : [];
            //init gallery form
            this.gallery_form.title = '';
            this.gallery_form.description = '';
            this.gallery_form.file = null;
            this.gallery_form.loaded_file_path = '';
            this.gallery_form.from_media_library_id = false;
        },
        clearErrors(){
            this.errors.logo_file = null;
            this.errors.preview_file = null;
            this.errors.file = null;
            this.errors.title = null;
        },
        changeUploadBoxState: changeUploadBoxState,
        selectFileFromMediaLibrary: selectFileFromMediaLibrary,
        ///////////methods used inside features
        initStateInAllFeatures(){
            this.$page.props.errors = {};
            this.feature_panorama_form.feature_files = this.generateFeatureFiles();
            this.feature_audioguide_form.feature_audio_files = this.generateLanguagesForAudioInAudioGuideFeature();
            this.feature_audioguide_form.feature_audio_preview_images = this.generatePreviewImagesInAudioGuideFeature();
            this.feature_video_form.feature_video_files = this.generateFeatureVideoFiles();
            this.feature_augmented_reality_form.general = {
                scale_percentage: 100,
                animation_loop: false,
                subtype: 'ar-markerbased',
                with_audio: true,
                marker_file: null,
                marker_position: [0,0,0],
                marker_rotation: [0,0,0],
                loop_audio: true,
                volume_percentage: 50,
            };
            this.feature_augmented_reality_form.languages = this.generateLangsForAugmentedRealityFeature();

            //---set language to fallback
            this.feature_panorama_form.current_language =
            this.$page.props.tour.data.fallback_language;

            this.feature_audioguide_form.current_language =
            this.$page.props.tour.data.fallback_language;

            this.feature_video_form.current_language =
            this.$page.props.tour.data.fallback_language;
            //---set language to fallback

        },
        //panorama feature
        generateFeatureFiles(){
            //demo data with structure of request, data will be changed in form
            const obj = {
                panorama_files : {
                    file_type : 'panorama_image',
                    languages : this.generateLanguagesForPanorama(),
                    panorama_type : 'default',
                },
                audio_files : {
                    file_type : 'audio',
                    languages : this.generateLanguagesForAudioInPanoramaFeature(),
                    info: {
                        loop: false,
                        volume: 40,
                    }
                },
            }
            return obj;
        },
        generateLanguagesForPanorama(){
            const obj = {};
            const langs = this.$page.props.tour.data.languages;
            langs.forEach(el => {
                obj[el] = {
                    'file' : null,
                    'copyright_text' : '',
                    'copyright_link' : '',
                    'loaded_file_path': '',
                    'from_media_library_id': null
                }
            })

            return obj;
        },
        generateLanguagesForAudioInPanoramaFeature(){
            const obj = {};
            const langs = this.$page.props.tour.data.languages;
            langs.forEach(el => {
                obj[el] = {
                    'file' : null,
                    'copyright_text' : '',
                    'copyright_link' : '',
                    'loaded_file_path': '',
                    'from_media_library_id': null
                }
            });
            return obj;
        },
        //audioguide feature
        generateLanguagesForAudioInAudioGuideFeature(){
            const obj = {};
            const langs = this.$page.props.tour.data.languages;
            langs.forEach(el => {
                obj[el] = {
                    'title' : '',
                    'file' : null,
                    'copyright_text' : '',
                    'copyright_link' : '',
                    'loaded_file_path': '',
                    'from_media_library_id': null
                }
            })

            return obj;
        },
        generatePreviewImagesInAudioGuideFeature(){
            const obj = {};
            const langs = this.$page.props.tour.data.languages;
            langs.forEach(el => {
                obj[el] = {
                    'file': null,
                    'copyright_text' : '',
                    'copyright_link' : '',
                    'loaded_file_path': '',
                    'from_media_library_id': null
                }
            })

            return obj;
        },
        // video feature
        generateFeatureVideoFiles(){
            //demo data with structure of request, data will be changed in form
            const obj = {
                file_type : 'video',
                languages : this.generateLanguagesForVideo(),
            }
            return obj;
        },
        generateLanguagesForVideo(){
            const obj = {};
            const langs = this.$page.props.tour.data.languages;
            langs.forEach(el => {
                obj[el] = {
                    'file' : null,
                    'copyright_text' : '',
                    'copyright_link' : '',
                    'loaded_file_path': '',
                    'from_media_library_id': null
                }
            })

            return obj;
        },
        // text feature
        generateLanguagesForTextFields(){
            let obj = {};
            this.$page.props.tour.data.languages.forEach(el => {
                obj[el] = '';
            })
            return obj;
        },
        // AugmentedRealityFeature
        generateLangsForAugmentedRealityFeature(){
            let obj = {};
            this.$page.props.tour.data.languages.forEach(el => {
                obj[el] = {
                    glb_file: null,
                    usdz_file: null,
                    audio_file: null,
                };
            })
            return obj;
        },
        ////////end methods used inside features
        showFeatureDeleteConfirmationModal:showFeatureDeleteConfirmationModal,
        showEditFeatureForm: showEditFeatureForm,
        closeEditFeatureModal: closeEditFeatureModal,
        showFallbackLang: showFallbackLang,

        showPreventFallbackLangModal:showPreventFallbackLangModal,
        hidePreventFallbackLangModal:hidePreventFallbackLangModal,
        runDeleteInAllLanguagesForm:runDeleteInAllLanguagesForm,
    }
}
</script>
